import * as React from "react";
import { Form, Icon, Input, Button, Checkbox, message, Typography } from "antd";
import { FormComponentProps } from "antd/lib/form";
import "./LoginForm.less";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { UsernamePassword } from "./UsernamePassword";
import { connect } from "react-redux";
import { saveSession, saveLoginRemember, SessionState } from "./State";
import { LoginResult } from "../Api/PapiClient";
import { AppState } from "../Store/RootReducer";
import { Currency } from "swan-public-api-client";
import { useState } from "react";

const FormItem = Form.Item;

interface LoginProps {
  onLogin: (request: UsernamePassword) => Promise<LoginResult>;
  saveSessionAction: (session: SessionState) => void;
  saveLoginRememberAction: (remember: boolean) => void;
  remember: boolean;
}

interface Props extends FormComponentProps, WrappedComponentProps, LoginProps {}

interface LoginFormFields {
  password: string;
  username: string;
  remember: boolean;
}

function LoginFormCmp(props: Props) {
  const [loading, setLoading] = useState(false);

  const { remember } = props;
  const { getFieldDecorator } = props.form;
  // todo: problem: there's no compile time safety for the ids of the strings
  const usernamePlaceholder = props.intl.formatMessage({
    id: "loginForm.usernamePlaceholder"
  });
  const usernameValidationMessage = props.intl.formatMessage({
    id: "loginForm.usernameValidationMessage"
  });
  const passwordPlaceholder = props.intl.formatMessage({
    id: "loginForm.passwordPlaceholder"
  });
  const passwordValidationMessage = props.intl.formatMessage({
    id: "loginForm.passwordValidationMessage"
  });
  return (
    <Form onSubmit={e => handleSubmit(e, props, setLoading)} className="login-form">
      <img src="/images/axi-logo.png" width="290px" height="90px" style={{ display: "block", margin: "8px auto" }} alt="axi" />
      <Typography.Paragraph style={{ textAlign: "center" }}>
        Any issues please contact our middle office team at <a href="mailto:Middle.Office.Requests@axicorp.com" target="_blank" rel="noopener noreferrer">Middle.Office.Requests@axicorp.com</a>
      </Typography.Paragraph>
      <FormItem>
        {getFieldDecorator("username", {
          rules: [{ required: true, message: usernameValidationMessage }]
        })(
          <Input
            prefix={<Icon type="user" className="login-form-ant-icon" />}
            placeholder={usernamePlaceholder}
          />
        )}
      </FormItem>
      <FormItem>
        {getFieldDecorator("password", {
          rules: [{ required: true, message: passwordValidationMessage }]
        })(
          <Input
            prefix={<Icon type="lock" className="login-form-ant-icon" />}
            type="password"
            placeholder={passwordPlaceholder}
          />
        )}
      </FormItem>
      <FormItem>
        {getFieldDecorator("remember", {
          valuePropName: "checked",
          initialValue: remember
        })(<Checkbox>Remember me</Checkbox>)}
        <Button
          type="primary"
          htmlType="submit"
          className="login-form-button"
          loading={loading}
        >
          Log in
        </Button>
      </FormItem>
    </Form>
  );
}

function handleSubmit(e: React.FormEvent, props: Props, setLoading: (loading: boolean) => void) {
  e.preventDefault();
  const { form, saveSessionAction, saveLoginRememberAction } = props;
  form.validateFields((err, values: LoginFormFields) => {
    if (!err) {
      setLoading(true);

      const { remember } = values;
      saveLoginRememberAction(remember);
      props
        .onLogin({
          password: values.password,
          username: values.username
        })
        .then(result => {
          setLoading(false);

          if (!result.success) {
            message.error("Log in failed. Please check your username and password and try again.");
            return;
          }

          if (remember) {
            const currencies: { [key: number]: Currency } = {};
            result.authenticationResponse.Configuration.Currencies.forEach(
              (x, y) => (currencies[y] = x)
            );
            saveSessionAction({
              token: result.authenticationResponse.Authentication.Token,
              currencies
            });
          }
        });
    }
  });
}

const intlLoginForm = Form.create()(injectIntl(LoginFormCmp));

// casting required because I think the type of form coming back from antd has lost the type info of props
const loginForm = (intlLoginForm as unknown) as React.ComponentClass<
  LoginProps
>;

const mapDispatchToProps = (dispatch: any) => ({
  saveSessionAction: (session: SessionState) => dispatch(saveSession(session)),
  saveLoginRememberAction: (remember: boolean) =>
    dispatch(saveLoginRemember(remember))
});

const mapStateToProps = (state: AppState) => {
  const { remember } = state.login;
  return { remember };
};

const loginWithDispatch = connect(
  mapStateToProps,
  mapDispatchToProps
)(loginForm);

export const LoginForm = loginWithDispatch;
